import {max, min, range} from "lodash";
import React from "react";
import Pagination from "react-bootstrap/Pagination";

export default function ListPagination({totalPages, page, setPage}) {

  let pagination = '';
  if (totalPages > 0)
    pagination = (
      <div className="clearfix">
        <Pagination className="float-start m-0">
          {page > 1 &&
            <>
              <Pagination.First key='page-1' onClick={() => setPage(1)}/>
              <Pagination.Prev key='page-prev' onClick={() => setPage(page - 1)}/>
            </>
          }
          {max([1, page - 3]) > 1 &&
            <Pagination.Ellipsis key='page-e1' onClick={() => setPage(1)}/>
          }

          {range(max([1, page - 3]), page).map(i =>
            <Pagination.Item key={`page-${i}`} onClick={() => setPage(i)}>{i}</Pagination.Item>
          )}

          <Pagination.Item active key={`page-{page}`}>{page}</Pagination.Item>
          {range(min([totalPages + 1, page + 1]), min([totalPages + 1, page + 4])).map(i =>
            <Pagination.Item key={`page-${i}`} onClick={() => setPage(i)}>{i}</Pagination.Item>
          )}

          {min([totalPages, page + 3]) < totalPages &&
            <Pagination.Ellipsis key='page-e2'/>
          }

          {page < totalPages &&
            <>
              <Pagination.Next onClick={() => setPage(page + 1)}/>
              <Pagination.Last onClick={() => setPage(totalPages)}/>
            </>
          }
        </Pagination>
        <div className="float-end lh-lg">
          Pagina {page} din {totalPages}
        </div>
      </div>
    );

  return pagination;
};
